module.exports = __webpack_public_path__ + "img/frontend_base_renovavel.dc490fee.jpg";